import Vue from 'vue'
import Router from 'vue-router'
import permissionRouter from './permissionRouter'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

export const allRoutes = [
  // {
  //   path: '/',
  //   redirect: 'login',
  // },
  {
    path: '/login',
    component: () => import('@/views/login/index')
    // hidden: true
  },
  {
    path: '/reset',
    component: () => import('@/views/reset/index')
    // hidden: true
  },
  ...permissionRouter
]

const router = new Router({
  // mode: 'history', // require service support
  base: '/jf/',
  scrollBehavior: () => ({ y: 0 }),
  routes: allRoutes
})

export function resetRouter () {
  location.reload()
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js